import { gql, useQuery } from '@apollo/client';
import { createGlobalState } from 'react-use';
import { WheelPrize } from '~types';

interface PrizesData {
  getWheelPrizes: WheelPrize[];
}

const useWinGameValue = createGlobalState<WheelGame>(null);
const usePrizesValue = createGlobalState<WheelPrize[]>([]);

export const useWinGame = () => useWinGameValue();
export const usePrizes = () => usePrizesValue();

const timeoutFuncList = [];

export const clearTimeoutFuncList = () => {
  for (const key in timeoutFuncList) {
    clearTimeout(timeoutFuncList[key]);
    delete timeoutFuncList[key];
  }
};

export const sleepAction = (functions: Function[], timeoutList: number[]) => {
  let timeout = 0;

  for (const key in functions) {
    timeout += timeoutList[key];

    timeoutFuncList.push(setTimeout(functions[key], timeout));
  }
};

export const useGetWheelPrizes = () => {
  return useQuery<PrizesData>(
    gql`
      query GetWheelPrizes {
        getWheelPrizes {
          id
          color
          image
          name
          getChance
          showPopup
        }
      }
    `,
  );
};
